import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'completeExam/';

export const getExamsList = (reqData: Object) => {
  return axios.get(API_URL + 'getUserExams', { params: reqData });
};

export const addUserImage = (reqData: Object) => {
  return axios.put(API_URL + 'addUserImage', reqData);
};

export const addMisconductImage = (reqData: Object) => {
  return axios.put(API_URL + 'addMisconductImage', reqData);
};

export const examCaptures = (reqData: Object) => {
  return axios.put(API_URL + 'examCaptures', reqData);
};

export const getExam = (reqData: Object) => {
  return axios.get(API_URL + 'loadExam', { params: reqData });
};

export const getExamsDetails = (reqData: Object) => {
  return axios.get(API_URL + 'getUserExamDetails', { params: reqData });
};

export const getExamCompletionUserDetails = (reqData: Object) => {
  return axios.get(API_URL + 'getCompleteExamUserList', { params: reqData });
};

export const getCompleteExamUserReport = (reqData: Object) => {
  return axios.get(API_URL + 'getCompleteExamUserReport', { params: reqData });
};

export const addUserDetails = (reqData: Object) => {
  return axios.post(API_URL, reqData);
};

export const submitExam = (reqData: Object) => {
  return axios.put(API_URL + 'submitExam', reqData);
};

export const getExamPaper = (reqData: Object) => {
  return axios.get(API_URL + 'getExamDetailsForChecking', { params: reqData });
};

export const generateExamPdf = (reqData: Object) => {
  return axios.post(API_URL + 'generateExamPdf', reqData, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
    }
  })
};

export const addSingleMarks = (reqData: Object) => {
  return axios.put(API_URL + 'assignMark', reqData);
};

export const generateResult = (reqData: Object) => {
  return axios.put(API_URL + 'generateResult', reqData);
};

export const assessOMRs = (reqData: Object) => {
  return axios.post(API_URL + 'assessOMRs', reqData);
};

export const confirmAssessOMRs = (reqData: Object) => {
  return axios.post(API_URL + 'confirmAssessOMRs', reqData);
};

export const assessExcelSheet = (reqData: Object) => {
  return axios.post(API_URL + 'assessSheet', reqData);
};

export const getCompletedExam = (reqData: object) => {
  return axios.get(API_URL + 'getUserCompletedExams', { params: reqData });
};

export const recordMisconduct = (reqData: object) => {
  return axios.patch(API_URL + 'recordMisconduct', reqData);
};

export const recordAbruptBrowserExit = () => {
  return API_URL + 'abruptBrowserExit';
};

export const examResult = (reqData: object) => {
  return axios.get(API_URL + 'result', { params: reqData })
};

export const wrongResults = (reqData: object) => {
  return axios.post(API_URL + 'wrongAnswersReport', reqData, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
    }
  })
}